import React, { useState } from "react";
import { Menu, MenuItem, Sidebar, SubMenu } from "react-pro-sidebar";

import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronCircleLeft } from "@fortawesome/free-solid-svg-icons";
import { faChevronCircleRight } from "@fortawesome/free-solid-svg-icons";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { ModuleAccess } from "utils/moduleaccess";
import { includes } from "lodash";
import adminbg from "assets/icon/adminbg.svg";


// import adminbg from "assets/icon/adminbg.svg";
// import financialbg from "assets/icon/financialbg.svg";

const SideBar = () => {
  const [open, setOpen] = useState(true);
  const [admin, setAdmin] = useState(false);
  const [financial, setFinancial] = useState(false);
  const [target, setTarget] = useState(null);
  const { pathname } = useLocation();
  const [show, setShow] = useState(false);

  const handleMouseEnter = (id) => {
    if (open == true)
      setTarget(id)
    setShow(true);
  }
  const handleMouseLeave = () => {
    if (open == true)
      setShow(false);
    setTarget(null)
  }
  const hasModule = (code) => {
    //return modules.length > 0 && modules.filter(m => m.code == code).length > 0;
    return ModuleAccess(code);
  };

  const toggleAdmin = () => {
    setAdmin(!admin);
    setFinancial(false);
  };
  const { token_type, access_token, profile } =
    JSON.parse(localStorage.getItem('pharmaforce')) || {};
  const { sub, roles } = profile || {};
  // debugger
  const toggleFinancial = () => {
    setAdmin(false);
    setFinancial(!financial);
  };

  const renderDashboard = () => {
    if (hasModule("DB"))
      return (
        <>
          <OverlayTrigger
            overlay={(props) => <Tooltip {...props}>Dashboard</Tooltip>}
            placement="right"
            show={show && target == "Dashboard"}
          >
            <MenuItem
              component={
                <Link
                  className={`${includes(pathname, "/dashboard") ? "active" : ""
                    }`}
                  to="/dashboard"
                />
              }
              id="Dashboard"
              onMouseEnter={() => handleMouseEnter("Dashboard")}
              onMouseLeave={handleMouseLeave}
              icon={
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.5 1.5H2.5C1.94875 1.5 1.5 1.94875 1.5 2.5V6.5C1.5 7.05125 1.94875 7.5 2.5 7.5H6.5C7.05125 7.5 7.5 7.05125 7.5 6.5V2.5C7.5 1.94875 7.05125 1.5 6.5 1.5Z"
                    fill="#757575"
                  />
                  <path
                    d="M13.5 1.5H9.5C8.94875 1.5 8.5 1.94875 8.5 2.5V6.5C8.5 7.05125 8.94875 7.5 9.5 7.5H13.5C14.0512 7.5 14.5 7.05125 14.5 6.5V2.5C14.5 1.94875 14.0512 1.5 13.5 1.5Z"
                    fill="#757575"
                  />
                  <path
                    d="M6.5 8.5H2.5C1.94875 8.5 1.5 8.94875 1.5 9.5V13.5C1.5 14.0512 1.94875 14.5 2.5 14.5H6.5C7.05125 14.5 7.5 14.0512 7.5 13.5V9.5C7.5 8.94875 7.05125 8.5 6.5 8.5Z"
                    fill="#757575"
                  />
                  <path
                    d="M13.5 8.5H9.5C8.94875 8.5 8.5 8.94875 8.5 9.5V13.5C8.5 14.0512 8.94875 14.5 9.5 14.5H13.5C14.0512 14.5 14.5 14.0512 14.5 13.5V9.5C14.5 8.94875 14.0512 8.5 13.5 8.5Z"
                    fill="#757575"
                  />
                </svg>
              }
            >
              Dashboard
            </MenuItem>
          </OverlayTrigger>
        </>
      )
  };
  
  const renderPurchaseOrder = () => {
    if (hasModule('PO'))
    return (
      <>
        <OverlayTrigger
          overlay={(props) => (
            <Tooltip {...props}>
              Purchase Order
            </Tooltip>
          )}
          // onHide={open == false}
          placement="right"
          show={show && target == "PurchaseOrders"}
        >
          <MenuItem component={<Link className={`${(includes(pathname, "/purchase-orders")) ? "active" : ""}`} to="/purchase-orders" />}
            id="PurchaseOrders"
            onMouseEnter={() => handleMouseEnter("PurchaseOrders")}
            onMouseLeave={handleMouseLeave}

            icon={
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M2.90909 1C1.85473 1 1 1.85473 1 2.90909V13.0909C1 14.1453 1.85473 15 2.90909 15H13.0909C14.1453 15 15 14.1453 15 13.0909V2.90909C15 1.85473 14.1453 1 13.0909 1H10.5455V6.09091C10.5455 6.29546 10.4471 6.48755 10.2812 6.60715C10.1152 6.72676 9.9019 6.75928 9.70787 6.69461L8 6.12533L6.29215 6.69461C6.09809 6.75928 5.88477 6.72676 5.71882 6.60715C5.55288 6.48755 5.45455 6.29546 5.45455 6.09091V1H2.90909ZM6.72727 1H9.27273V5.208L8.20122 4.85084C8.07064 4.80729 7.92936 4.80729 7.79878 4.85084L6.72727 5.208V1ZM4.18182 10.5455V11.8182H6.72727V10.5455H4.18182Z"
                  fill="#757575"
                />
              </svg>
            }
            >

Purchase Order

          </MenuItem>
        </OverlayTrigger>


      </>
    )
  }

  const renderInventory = () => {
    if (hasModule('INV'))
    return (
      <>
        <OverlayTrigger
          overlay={(props) => (
            <Tooltip {...props}>
              Accumulations
            </Tooltip>
          )}
          // onHide={open == false}
          placement="right"
          show={show && target == "accumulations"}
        >
          <MenuItem component={<Link className={`${(includes(pathname, "/inventory-search")) ? "active" : ""}`} to="/inventory-search" />}
            id="accumulations"
            onMouseEnter={() => handleMouseEnter("accumulations")}
            onMouseLeave={handleMouseLeave}

            icon={

              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_2578_147693)">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M1.02674 8.4707C0.459688 8.4707 0 8.93039 0 9.49744V14.9734C0 15.5404 0.459688 16.0001 1.02674 16.0001H6.50267C7.06974 16.0001 7.52941 15.5404 7.52941 14.9734V9.49744C7.52941 8.93039 7.06974 8.4707 6.50267 8.4707H5.13369V11.2087C5.13369 11.3187 5.08081 11.422 4.99156 11.4863C4.9023 11.5506 4.78758 11.5681 4.68323 11.5334L3.76471 11.2272L2.8462 11.5334C2.74183 11.5681 2.6271 11.5506 2.53785 11.4863C2.44861 11.422 2.39572 11.3187 2.39572 11.2087V8.4707H1.02674ZM3.08021 8.4707H4.4492V10.7338L3.87292 10.5417C3.8027 10.5183 3.72672 10.5183 3.65649 10.5417L3.08021 10.7338V8.4707ZM1.71123 13.6044V14.2889H3.08021V13.6044H1.71123Z" fill="#757575" />
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.49744 8.4707C8.93039 8.4707 8.4707 8.93039 8.4707 9.49744V14.9734C8.4707 15.5404 8.93039 16.0001 9.49744 16.0001H14.9734C15.5404 16.0001 16.0001 15.5404 16.0001 14.9734V9.49744C16.0001 8.93039 15.5404 8.4707 14.9734 8.4707H13.6044V11.2087C13.6044 11.3187 13.5515 11.422 13.4623 11.4863C13.373 11.5506 13.2583 11.5681 13.1539 11.5334L12.2354 11.2272L11.3169 11.5334C11.2125 11.5681 11.0978 11.5506 11.0086 11.4863C10.9193 11.422 10.8664 11.3187 10.8664 11.2087V8.4707H9.49744ZM11.5509 8.4707H12.9199V10.7338L12.3436 10.5417C12.2734 10.5183 12.1974 10.5183 12.1272 10.5417L11.5509 10.7338V8.4707ZM10.1819 13.6044V14.2889H11.5509V13.6044H10.1819Z" fill="#757575" />
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M5.73182 0C5.16477 0 4.70508 0.459688 4.70508 1.02674V6.50267C4.70508 7.06974 5.16477 7.52941 5.73182 7.52941H11.2078C11.7748 7.52941 12.2345 7.06974 12.2345 6.50267V1.02674C12.2345 0.459688 11.7748 0 11.2078 0H9.83877V2.73797C9.83877 2.84798 9.78589 2.95129 9.69663 3.01561C9.60738 3.07994 9.49265 3.09743 9.3883 3.06265L8.46978 2.75648L7.55127 3.06265C7.44691 3.09743 7.33218 3.07994 7.24293 3.01561C7.15368 2.95129 7.1008 2.84798 7.1008 2.73797V0H5.73182ZM7.78529 0H9.15428V2.26313L8.578 2.07104C8.50777 2.04762 8.43179 2.04762 8.36157 2.07104L7.78529 2.26313V0ZM6.41631 5.13369V5.81818H7.78529V5.13369H6.41631Z" fill="#757575" />
                </g>
                <defs>
                  <clipPath id="clip0_2578_147693">
                    <rect width="16" height="16" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            }
            >

            Accumulations

          </MenuItem>
        </OverlayTrigger>


      </>
    )
  }
  const renderreports = () => {
    if (hasModule('REP'))
    return (
      <>
        <OverlayTrigger
          overlay={(props) => (
            <Tooltip {...props}>
              Reports
            </Tooltip>
          )}
          // onHide={open == false}
          placement="right"
          show={show && target == "Reports"}
        >
          <MenuItem component={<Link className={`${(includes(pathname, "/reports")) ? "active" : ""}`} to="/reports" />}
            id="Reports"
            onMouseEnter={() => handleMouseEnter("Reports")}
            onMouseLeave={handleMouseLeave}

            icon={
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >

                <path d="M11.4583 4.38089C10.8967 4.38089 10.4396 3.92395 10.4396 3.36227V0.492188H3.1319C2.22772 0.492188 1.49219 1.22772 1.49219 2.1319V13.8525C1.49219 14.7567 2.22772 15.4922 3.1319 15.4922H12.7431C13.6474 15.4922 14.3828 14.7567 14.3828 13.8525V4.38089H11.4583ZM10.4538 11.8594H4.79358C4.55087 11.8594 4.35413 11.6626 4.35413 11.4199C4.35413 11.1772 4.55087 10.9805 4.79358 10.9805H10.4538C10.6966 10.9805 10.8933 11.1772 10.8933 11.4199C10.8933 11.6626 10.6966 11.8594 10.4538 11.8594ZM4.35413 9.66211C4.35413 9.4194 4.55087 9.22266 4.79358 9.22266H9.84454C10.0873 9.22266 10.284 9.4194 10.284 9.66211C10.284 9.90482 10.0872 10.1016 9.84454 10.1016H4.79358C4.55087 10.1016 4.35413 9.90482 4.35413 9.66211ZM10.9882 8.34375H4.79358C4.55087 8.34375 4.35413 8.147 4.35413 7.9043C4.35413 7.66159 4.55087 7.46484 4.79358 7.46484H10.9882C11.2309 7.46484 11.4277 7.66159 11.4277 7.9043C11.4277 8.147 11.2309 8.34375 10.9882 8.34375Z" fill="#FEFEFE" />

                <path d="M11.4583 4.38089C10.8967 4.38089 10.4396 3.92395 10.4396 3.36227V0.492188H3.1319C2.22772 0.492188 1.49219 1.22772 1.49219 2.1319V13.8525C1.49219 14.7567 2.22772 15.4922 3.1319 15.4922H12.7431C13.6474 15.4922 14.3828 14.7567 14.3828 13.8525V4.38089H11.4583ZM10.4538 11.8594H4.79358C4.55087 11.8594 4.35413 11.6626 4.35413 11.4199C4.35413 11.1772 4.55087 10.9805 4.79358 10.9805H10.4538C10.6966 10.9805 10.8933 11.1772 10.8933 11.4199C10.8933 11.6626 10.6966 11.8594 10.4538 11.8594ZM4.35413 9.66211C4.35413 9.4194 4.55087 9.22266 4.79358 9.22266H9.84454C10.0873 9.22266 10.284 9.4194 10.284 9.66211C10.284 9.90482 10.0872 10.1016 9.84454 10.1016H4.79358C4.55087 10.1016 4.35413 9.90482 4.35413 9.66211ZM10.9882 8.34375H4.79358C4.55087 8.34375 4.35413 8.147 4.35413 7.9043C4.35413 7.66159 4.55087 7.46484 4.79358 7.46484H10.9882C11.2309 7.46484 11.4277 7.66159 11.4277 7.9043C11.4277 8.147 11.2309 8.34375 10.9882 8.34375Z" fill="#702C62" />


                <path d="M11.4583 4.38089C10.8967 4.38089 10.4396 3.92395 10.4396 3.36227V0.492188H3.1319C2.22772 0.492188 1.49219 1.22772 1.49219 2.1319V13.8525C1.49219 14.7567 2.22772 15.4922 3.1319 15.4922H12.7431C13.6474 15.4922 14.3828 14.7567 14.3828 13.8525V4.38089H11.4583ZM10.4538 11.8594H4.79358C4.55087 11.8594 4.35413 11.6626 4.35413 11.4199C4.35413 11.1772 4.55087 10.9805 4.79358 10.9805H10.4538C10.6966 10.9805 10.8933 11.1772 10.8933 11.4199C10.8933 11.6626 10.6966 11.8594 10.4538 11.8594ZM4.35413 9.66211C4.35413 9.4194 4.55087 9.22266 4.79358 9.22266H9.84454C10.0873 9.22266 10.284 9.4194 10.284 9.66211C10.284 9.90482 10.0872 10.1016 9.84454 10.1016H4.79358C4.55087 10.1016 4.35413 9.90482 4.35413 9.66211ZM10.9882 8.34375H4.79358C4.55087 8.34375 4.35413 8.147 4.35413 7.9043C4.35413 7.66159 4.55087 7.46484 4.79358 7.46484H10.9882C11.2309 7.46484 11.4277 7.66159 11.4277 7.9043C11.4277 8.147 11.2309 8.34375 10.9882 8.34375Z" fill="#757575" />

              </svg>
            }
            >

Reports

          </MenuItem>
        </OverlayTrigger>


      </>
    )
  }



  const rendercontracts = () => {
    if (hasModule('CON'))
    return (
      <>
        <OverlayTrigger
          overlay={(props) => (
            <Tooltip {...props}>
              Contracts
            </Tooltip>
          )}
          // onHide={open == false}
          placement="right"
          show={show && target == "Contracts"}
        >
          <MenuItem component={<Link className={`${(includes(pathname, "/contracts")) ? "active" : ""}`} to="/contracts" />}
            id="Contracts"
            onMouseEnter={() => handleMouseEnter("Contracts")}
            onMouseLeave={handleMouseLeave}

            icon={
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M15.6507 5.15548C15.179 4.69326 14.4188 4.69326 13.9501 5.15548L11.4173 7.65328V3.55558C11.4173 3.55558 11.4142 3.53484 11.4142 3.52595C11.4142 3.51113 11.4142 3.49336 11.4052 3.47854C11.4052 3.47262 11.4022 3.46669 11.3992 3.46076C11.3932 3.44299 11.3842 3.42817 11.3752 3.41336C11.3632 3.38965 11.3481 3.36299 11.3271 3.34225L8.0251 0.0859249C7.99806 0.0592592 7.96501 0.0355556 7.92896 0.0237037C7.92595 0.0237037 7.92295 0.0237037 7.91694 0.0207407C7.90192 0.0148148 7.8869 0.00888889 7.87187 0.00592593C7.85084 0 7.82981 0 7.81478 0H0.901362C0.405618 0 0 0.400005 0 0.888889V15.1111C0 15.6 0.405618 16 0.901362 16H10.5159C11.0147 16 11.4173 15.6 11.4173 15.1111V11.0104L15.6507 6.83852C16.1164 6.3763 16.1164 5.62371 15.6507 5.16147L15.6507 5.15548ZM13.7368 6.2014L14.5871 7.03993L9.91212 11.6502L9.06183 10.8117L13.7368 6.2014ZM1.8419 7.4014C1.67664 7.4014 1.54144 7.26807 1.54144 7.1051C1.54144 6.94214 1.67664 6.80881 1.8419 6.80881H8.75243C8.91768 6.80881 9.05289 6.94214 9.05289 7.1051C9.05289 7.26807 8.91768 7.4014 8.75243 7.4014H1.8419ZM1.8419 8.88288H6.94952C7.11477 8.88288 7.24997 9.01621 7.24997 9.17918C7.24997 9.34214 7.11477 9.47547 6.94952 9.47547H1.8419C1.67664 9.47547 1.54144 9.34214 1.54144 9.17918C1.54144 9.01621 1.67664 8.88288 1.8419 8.88288ZM8.75243 13.5555C8.91768 13.5555 9.05289 13.6889 9.05289 13.8518C9.05289 14.0148 8.91768 14.1481 8.75243 14.1481H5.87711C5.71186 14.1481 5.57666 14.0148 5.57666 13.8518C5.57666 13.6889 5.71186 13.5555 5.87711 13.5555H8.75243ZM8.47601 12.2281L8.76745 11.36L9.35634 11.9378L8.47601 12.2281ZM8.75243 5.32733H1.8419C1.67664 5.32733 1.54144 5.19399 1.54144 5.03103C1.54144 4.86807 1.67664 4.73473 1.8419 4.73473H8.75243C8.91768 4.73473 9.05289 4.86807 9.05289 5.03103C9.05289 5.19399 8.91768 5.32733 8.75243 5.32733ZM8.41292 3.25316C8.24767 3.25316 8.11247 3.11982 8.11247 2.95686V1.00424L10.3928 3.25306L8.41292 3.25316ZM1.84197 10.9569H6.94959C7.11484 10.9569 7.25005 11.0902 7.25005 11.2532C7.25005 11.4161 7.11484 11.5495 6.94959 11.5495H1.84197C1.67672 11.5495 1.54152 11.4161 1.54152 11.2532C1.54152 11.0902 1.67672 10.9569 1.84197 10.9569ZM15.2242 6.41163L15.0109 6.622L14.1606 5.78348L14.374 5.5731C14.6083 5.34198 14.9899 5.34198 15.2242 5.5731C15.4586 5.80423 15.4586 6.18051 15.2242 6.41163Z" fill="#FEFEFE" />

                <path d="M15.6507 5.15548C15.179 4.69326 14.4188 4.69326 13.9501 5.15548L11.4173 7.65328V3.55558C11.4173 3.55558 11.4142 3.53484 11.4142 3.52595C11.4142 3.51113 11.4142 3.49336 11.4052 3.47854C11.4052 3.47262 11.4022 3.46669 11.3992 3.46076C11.3932 3.44299 11.3842 3.42817 11.3752 3.41336C11.3632 3.38965 11.3481 3.36299 11.3271 3.34225L8.0251 0.0859249C7.99806 0.0592592 7.96501 0.0355556 7.92896 0.0237037C7.92595 0.0237037 7.92295 0.0237037 7.91694 0.0207407C7.90192 0.0148148 7.8869 0.00888889 7.87187 0.00592593C7.85084 0 7.82981 0 7.81478 0H0.901362C0.405618 0 0 0.400005 0 0.888889V15.1111C0 15.6 0.405618 16 0.901362 16H10.5159C11.0147 16 11.4173 15.6 11.4173 15.1111V11.0104L15.6507 6.83852C16.1164 6.3763 16.1164 5.62371 15.6507 5.16147L15.6507 5.15548ZM13.7368 6.2014L14.5871 7.03993L9.91212 11.6502L9.06183 10.8117L13.7368 6.2014ZM1.8419 7.4014C1.67664 7.4014 1.54144 7.26807 1.54144 7.1051C1.54144 6.94214 1.67664 6.80881 1.8419 6.80881H8.75243C8.91768 6.80881 9.05289 6.94214 9.05289 7.1051C9.05289 7.26807 8.91768 7.4014 8.75243 7.4014H1.8419ZM1.8419 8.88288H6.94952C7.11477 8.88288 7.24997 9.01621 7.24997 9.17918C7.24997 9.34214 7.11477 9.47547 6.94952 9.47547H1.8419C1.67664 9.47547 1.54144 9.34214 1.54144 9.17918C1.54144 9.01621 1.67664 8.88288 1.8419 8.88288ZM8.75243 13.5555C8.91768 13.5555 9.05289 13.6889 9.05289 13.8518C9.05289 14.0148 8.91768 14.1481 8.75243 14.1481H5.87711C5.71186 14.1481 5.57666 14.0148 5.57666 13.8518C5.57666 13.6889 5.71186 13.5555 5.87711 13.5555H8.75243ZM8.47601 12.2281L8.76745 11.36L9.35634 11.9378L8.47601 12.2281ZM8.75243 5.32733H1.8419C1.67664 5.32733 1.54144 5.19399 1.54144 5.03103C1.54144 4.86807 1.67664 4.73473 1.8419 4.73473H8.75243C8.91768 4.73473 9.05289 4.86807 9.05289 5.03103C9.05289 5.19399 8.91768 5.32733 8.75243 5.32733ZM8.41292 3.25316C8.24767 3.25316 8.11247 3.11982 8.11247 2.95686V1.00424L10.3928 3.25306L8.41292 3.25316ZM1.84197 10.9569H6.94959C7.11484 10.9569 7.25005 11.0902 7.25005 11.2532C7.25005 11.4161 7.11484 11.5495 6.94959 11.5495H1.84197C1.67672 11.5495 1.54152 11.4161 1.54152 11.2532C1.54152 11.0902 1.67672 10.9569 1.84197 10.9569ZM15.2242 6.41163L15.0109 6.622L14.1606 5.78348L14.374 5.5731C14.6083 5.34198 14.9899 5.34198 15.2242 5.5731C15.4586 5.80423 15.4586 6.18051 15.2242 6.41163Z" fill="#702C62" />

                <path d="M15.6507 5.15548C15.179 4.69326 14.4188 4.69326 13.9501 5.15548L11.4173 7.65328V3.55558C11.4173 3.55558 11.4142 3.53484 11.4142 3.52595C11.4142 3.51113 11.4142 3.49336 11.4052 3.47854C11.4052 3.47262 11.4022 3.46669 11.3992 3.46076C11.3932 3.44299 11.3842 3.42817 11.3752 3.41336C11.3632 3.38965 11.3481 3.36299 11.3271 3.34225L8.0251 0.0859249C7.99806 0.0592592 7.96501 0.0355556 7.92896 0.0237037C7.92595 0.0237037 7.92295 0.0237037 7.91694 0.0207407C7.90192 0.0148148 7.8869 0.00888889 7.87187 0.00592593C7.85084 0 7.82981 0 7.81478 0H0.901362C0.405618 0 0 0.400005 0 0.888889V15.1111C0 15.6 0.405618 16 0.901362 16H10.5159C11.0147 16 11.4173 15.6 11.4173 15.1111V11.0104L15.6507 6.83852C16.1164 6.3763 16.1164 5.62371 15.6507 5.16147L15.6507 5.15548ZM13.7368 6.2014L14.5871 7.03993L9.91212 11.6502L9.06183 10.8117L13.7368 6.2014ZM1.8419 7.4014C1.67664 7.4014 1.54144 7.26807 1.54144 7.1051C1.54144 6.94214 1.67664 6.80881 1.8419 6.80881H8.75243C8.91768 6.80881 9.05289 6.94214 9.05289 7.1051C9.05289 7.26807 8.91768 7.4014 8.75243 7.4014H1.8419ZM1.8419 8.88288H6.94952C7.11477 8.88288 7.24997 9.01621 7.24997 9.17918C7.24997 9.34214 7.11477 9.47547 6.94952 9.47547H1.8419C1.67664 9.47547 1.54144 9.34214 1.54144 9.17918C1.54144 9.01621 1.67664 8.88288 1.8419 8.88288ZM8.75243 13.5555C8.91768 13.5555 9.05289 13.6889 9.05289 13.8518C9.05289 14.0148 8.91768 14.1481 8.75243 14.1481H5.87711C5.71186 14.1481 5.57666 14.0148 5.57666 13.8518C5.57666 13.6889 5.71186 13.5555 5.87711 13.5555H8.75243ZM8.47601 12.2281L8.76745 11.36L9.35634 11.9378L8.47601 12.2281ZM8.75243 5.32733H1.8419C1.67664 5.32733 1.54144 5.19399 1.54144 5.03103C1.54144 4.86807 1.67664 4.73473 1.8419 4.73473H8.75243C8.91768 4.73473 9.05289 4.86807 9.05289 5.03103C9.05289 5.19399 8.91768 5.32733 8.75243 5.32733ZM8.41292 3.25316C8.24767 3.25316 8.11247 3.11982 8.11247 2.95686V1.00424L10.3928 3.25306L8.41292 3.25316ZM1.84197 10.9569H6.94959C7.11484 10.9569 7.25005 11.0902 7.25005 11.2532C7.25005 11.4161 7.11484 11.5495 6.94959 11.5495H1.84197C1.67672 11.5495 1.54152 11.4161 1.54152 11.2532C1.54152 11.0902 1.67672 10.9569 1.84197 10.9569ZM15.2242 6.41163L15.0109 6.622L14.1606 5.78348L14.374 5.5731C14.6083 5.34198 14.9899 5.34198 15.2242 5.5731C15.4586 5.80423 15.4586 6.18051 15.2242 6.41163Z" fill="#757575" />

              </svg>
            }
            >

Contracts

          </MenuItem>
        </OverlayTrigger>


      </>
    )
  }



  const renderformulary = () => {
    if (hasModule('FOR'))
    return (
      <>
        <OverlayTrigger
          overlay={(props) => (
            <Tooltip {...props}>
              Formulary
            </Tooltip>
          )}
          // onHide={open == false}
          placement="right"
          show={show && target == "formulary"}
        >
          <MenuItem component={<Link className={`${(includes(pathname, "/formulary")) ? "active" : ""}`} to="/formulary" />}
            id="formulary"
            onMouseEnter={() => handleMouseEnter("formulary")}
            onMouseLeave={handleMouseLeave}

            icon={


              <svg width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M5.97501 0H10.8802C11.0698 0 11.2256 0.16041 11.2256 0.355543V2.15957C11.2256 2.35471 11.0698 2.51511 10.8802 2.51511H10.5584V1.25752C10.5584 1.07698 10.416 0.930456 10.2406 0.930456C10.0652 0.930456 9.9229 1.07698 9.9229 1.25752V2.51511H9.34879V1.25752C9.34879 1.07698 9.20644 0.930456 9.03105 0.930456C8.85632 0.930456 8.71465 1.07698 8.71465 1.25752V2.51511H8.14055V1.25752C8.14055 1.07698 7.9982 0.930456 7.8228 0.930456C7.64741 0.930456 7.50506 1.07698 7.50506 1.25752V2.51511H6.93095V1.25752C6.93095 1.07698 6.78861 0.930456 6.61456 0.930456C6.43916 0.930456 6.29681 1.07698 6.29681 1.25752V2.51511H5.97501C5.78409 2.51511 5.62893 2.3547 5.62893 2.15957V0.355543C5.62893 0.160403 5.78409 0 5.97501 0ZM5.2201 14.5321V10.8642C5.2201 10.0572 4.57854 9.39754 3.79529 9.39754C3.01069 9.39754 2.36912 10.0579 2.36912 10.8642V12.4787C2.92502 12.7377 3.36893 13.2412 3.53757 13.8911C3.71905 14.5897 3.54365 15.305 3.1274 15.8285C3.32708 15.9375 3.55378 16 3.79529 16C4.57854 15.9993 5.2201 15.339 5.2201 14.5321ZM1.11438 12.9572C0.963943 12.9988 0.825639 13.062 0.700842 13.1433L2.75776 15.3057C2.98713 14.9495 3.07281 14.496 2.95677 14.0509C2.74089 13.2259 1.91653 12.7356 1.11438 12.9572ZM0.248838 13.5995C0.0201424 13.9557 -0.0641894 14.4071 0.0518512 14.8516C0.267059 15.6779 1.09078 16.1668 1.89289 15.9459C2.04198 15.9043 2.18096 15.8411 2.30508 15.7605L0.248838 13.5995ZM4.61638 12.6988V10.8642C4.61638 10.4004 4.24601 10.0177 3.79468 10.0177C3.34335 10.0177 2.97231 10.4004 2.97231 10.8642V12.6988H4.61638ZM10.2407 3.13598V4.49634L12.4596 5.83796H4.39514L6.61475 4.49634V3.13598H10.2407ZM13 6.49213V14.4343C13 15.2967 12.3173 15.9995 11.4794 15.9995H5.3746C5.3294 15.9995 5.28488 15.9967 5.24035 15.9932C5.59993 15.6162 5.82256 15.1002 5.82256 14.5329L5.82323 10.8642C5.82323 9.73645 4.9442 8.81076 3.85526 8.77751V6.49226L13 6.49213ZM7.78448 8.34131H9.07099V9.61001H10.3035V10.9343H9.07099V12.203H7.78448V10.9343H6.55193V9.61001H7.78448V8.34131Z" fill="#757575" />
              </svg>

            }
            >

Formulary

          </MenuItem>
        </OverlayTrigger>


      </>
    )
  }
const renderConfiguration = () => {
     if (hasModule('CONFIG'))
    return (
      <>
        <OverlayTrigger
          overlay={(props) => (
            <Tooltip {...props}>
              Configurations
            </Tooltip>
          )}
          // onHide={open == false}
          placement="right"
          show={show && target == "Configuration"}
        >
          <MenuItem component={<Link className={`${(includes(pathname, "/configuration")) ? "active" : ""}`} to="/configuration" />}
            id="Configuration"
            onMouseEnter={() => handleMouseEnter("Configuration")}
            onMouseLeave={handleMouseLeave}

           icon={
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_2578_148733)">
                        <g clip-path="url(#clip1_2578_148733)">
                          <path
                            d="M3.86133 8.81772L3.86136 8.81784C3.87127 8.80784 3.87061 8.80843 3.86133 8.81772Z"
                            fill="#757575"
                          />
                          <path
                            d="M15.6453 6.60712L14.8496 6.41581C14.6766 5.66059 14.3787 4.94291 13.9622 4.27559L14.3654 3.59866C14.4753 3.41422 14.4455 3.17894 14.294 3.02744L12.9726 1.70603C12.8211 1.555 12.5863 1.52478 12.4014 1.63463L11.7244 2.03784C11.0571 1.62134 10.3394 1.32337 9.5842 1.15038L9.39289 0.35475C9.3407 0.1465 9.15352 0 8.93839 0H7.06364C6.84852 0 6.66133 0.146469 6.60914 0.35475L6.41783 1.15038C5.66261 1.32337 4.94492 1.62134 4.27761 2.03784L3.60067 1.63463C3.41623 1.52475 3.18095 1.55453 3.02945 1.70603L1.70798 3.02741C1.55648 3.17891 1.52673 3.41416 1.63658 3.59862L2.0398 4.27556C1.6233 4.94287 1.32533 5.66056 1.15233 6.41578L0.356703 6.60709C0.148453 6.65928 0.00195312 6.84647 0.00195312 7.06159V8.93634C0.00195312 9.15147 0.148422 9.33912 0.357141 9.39084L1.15277 9.58216C1.26811 10.0826 1.4417 10.5634 1.66464 11.0245C2.00886 10.6789 3.73767 8.94266 3.86192 8.81856C3.8558 8.787 3.78883 8.18666 3.78705 8.06972C3.74717 5.68137 5.67089 3.78119 8.0028 3.78119C10.3507 3.78119 12.2229 5.67437 12.214 8.01359C12.204 10.1769 10.5893 12.0186 8.3342 12.1871C8.23664 12.1946 7.79558 12.2596 7.1808 12.1384L4.98108 14.3382C5.44045 14.5597 5.91942 14.7322 6.4178 14.8471L6.60911 15.6432C6.6613 15.8515 6.84848 15.998 7.06361 15.998H8.93836C9.15348 15.998 9.34067 15.8515 9.39286 15.6432L9.58417 14.8476C10.3394 14.6746 11.0571 14.3766 11.7244 13.9601L12.4013 14.3633C12.5849 14.4732 12.8206 14.443 12.9725 14.2919L14.294 12.9705C14.4455 12.819 14.4752 12.5838 14.3654 12.3993L13.9621 11.7224C14.3791 11.0551 14.6766 10.3374 14.8496 9.58169L15.6448 9.39084C15.8535 9.33912 16 9.15147 16 8.93634V7.06159C16 6.8465 15.8535 6.65928 15.6453 6.60712Z"
                            fill="#757575"
                          />
                          <path
                            d="M11.1725 7.14356C11.1313 6.98219 11.0067 6.85525 10.8461 6.81125C10.6855 6.76719 10.5139 6.81309 10.3961 6.93084L9.32655 8.00044C8.96096 8.36603 8.36665 8.36603 8.00102 8.00044C7.63577 7.63519 7.63577 7.04019 8.00102 6.67491L9.07102 5.60491C9.18877 5.48716 9.23424 5.31528 9.19021 5.15475C9.14615 4.99422 9.01937 4.86944 8.85802 4.82844C6.88033 4.32585 5.10058 5.61406 4.77418 7.39303C4.66937 7.97891 4.71605 8.56247 4.9078 9.09981C4.64112 9.36653 0.521928 13.4857 0.411209 13.5964C-0.138509 14.1462 -0.138509 15.0405 0.419897 15.5989C0.973084 16.1233 1.8203 16.1453 2.40496 15.5902L6.90158 11.0936C7.62168 11.3506 8.42477 11.3454 9.21068 11.0681C10.6268 10.5684 11.6179 8.89141 11.1725 7.14356Z"
                            fill="#757575"
                          />
                        </g>
                      </g>
                      <defs>
                        <clipPath id="clip0_2578_148733">
                          <rect width="16" height="16" fill="white" />
                        </clipPath>
                        <clipPath id="clip1_2578_148733">
                          <rect width="16" height="16" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  }
            >

Configuration

          </MenuItem>
        </OverlayTrigger>


      </>
    )
  }

  const renderinvoice = () => {
    if (hasModule('INVOICE'))
    return (
      <>
        <OverlayTrigger
          overlay={(props) => (
            <Tooltip {...props}>
              Invoice
            </Tooltip>
          )}
          // onHide={open == false}
          placement="right"
          show={show && target == "Invoice"}
        >
          <MenuItem component={<Link className={`${(includes(pathname, "/Invoice")) ? "active" : ""}`} to="/Invoice" />}
            id="Invoice"
            onMouseEnter={() => handleMouseEnter("Invoice")}
            onMouseLeave={handleMouseLeave}

            icon={
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_2578_148324)">
                  <g clip-path="url(#clip1_2578_148324)">
                    <path
                      d="M10.8438 5.6875C8.00059 5.6875 5.6875 8.00059 5.6875 10.8438C5.6875 13.6869 8.00059 16 10.8438 16C13.6869 16 16 13.6869 16 10.8438C16 8.00059 13.6869 5.6875 10.8438 5.6875ZM10.8438 10.375C11.6192 10.375 12.25 11.0058 12.25 11.7812C12.25 12.3916 11.8569 12.907 11.3125 13.1012V14.125H10.375V13.1012C9.83056 12.907 9.4375 12.3916 9.4375 11.7812H10.375C10.375 12.0399 10.5851 12.25 10.8438 12.25C11.1024 12.25 11.3125 12.0399 11.3125 11.7812C11.3125 11.5226 11.1024 11.3125 10.8438 11.3125C10.0683 11.3125 9.4375 10.6817 9.4375 9.90625C9.4375 9.29594 9.83056 8.7805 10.375 8.58634V7.5625H11.3125V8.58634C11.8569 8.7805 12.25 9.29594 12.25 9.90625H11.3125C11.3125 9.64762 11.1024 9.4375 10.8438 9.4375C10.5851 9.4375 10.375 9.64762 10.375 9.90625C10.375 10.1649 10.5851 10.375 10.8438 10.375Z"
                      fill="#757575"
                    />
                    <path
                      d="M5.21875 5.6875C8.11 5.6875 10.375 4.452 10.375 2.875C10.375 1.298 8.11 0 5.21875 0C2.3275 0 0 1.298 0 2.875C0 4.452 2.3275 5.6875 5.21875 5.6875Z"
                      fill="#757575"
                    />
                    <path
                      d="M0 10.5488V11.3126C0 12.8896 2.3275 14.1251 5.21875 14.1251C5.38275 14.1251 5.54166 14.11 5.70312 14.1021C5.34356 13.5368 5.07541 12.9095 4.9175 12.2388C2.82672 12.1811 1.01131 11.5386 0 10.5488Z"
                      fill="#757575"
                    />
                    <path
                      d="M4.77253 11.2887C4.76178 11.1413 4.75 10.994 4.75 10.8439C4.75 10.3552 4.81403 9.88227 4.92322 9.42658C2.82984 9.36986 1.01222 8.72705 0 7.73633V8.50011C0 9.99345 2.10194 11.167 4.77253 11.2887Z"
                      fill="#757575"
                    />
                    <path
                      d="M5.21875 8.50011C5.21925 8.50011 5.21966 8.50005 5.22019 8.50005C5.52934 7.76117 5.97875 7.09511 6.53684 6.53705C6.1135 6.59055 5.676 6.62511 5.21875 6.62511C2.99322 6.62511 1.06019 5.96145 0 4.92383V5.68761C0 7.26461 2.3275 8.50011 5.21875 8.50011Z"
                      fill="#757575"
                    />
                  </g>
                </g>
                <defs>
                  <clipPath id="clip0_2578_148324">
                    <rect width="16" height="16" fill="white" />
                  </clipPath>
                  <clipPath id="clip1_2578_148324">
                    <rect width="16" height="16" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            }
            >

Invoice

          </MenuItem>
        </OverlayTrigger>


      </>
    )
  }

  const renderrxmanager = () => {
    if (hasModule('RXM'))
    return (
      <>
        <OverlayTrigger
          overlay={(props) => (
            <Tooltip {...props}>
              Rx Manager
            </Tooltip>
          )}
          // onHide={open == false}
          placement="right"
          show={show && target == "Rx Manager"}
        >
          <MenuItem component={<Link className={`${(includes(pathname, "/rx-manager")) ? "active" : ""}`} to="/rx-manager" />}
            id="Rx Manager"
            onMouseEnter={() => handleMouseEnter("Rx Manager")}
            onMouseLeave={handleMouseLeave}

            icon={
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.3252 13.7734C11.0759 13.7734 10.873 13.9763 10.873 14.2256C10.873 14.4791 11.0716 14.6777 11.3252 14.6777C11.5745 14.6777 11.7774 14.4748 11.7774 14.2256C11.7774 13.9763 11.5745 13.7734 11.3252 13.7734Z"
                  fill="#757575"
                />
                <path
                  d="M12.4534 6.49691V3.19176L10.1779 3.32938C10.1776 3.32938 10.1773 3.32938 10.177 3.32938C9.67309 3.32938 9.27645 2.93248 9.27645 2.44456V0H1.54925C1.24637 0 1 0.244808 1 0.545608V15.2423C1 15.3627 1.09805 15.4608 1.21863 15.4608H9.08204V7.27027C9.08204 6.8438 9.42737 6.49691 9.85188 6.49691H12.4534ZM2.9414 1.34748C2.9414 1.26753 2.97044 1.195 3.02539 1.13796C3.08152 1.07989 3.15418 1.04916 3.23543 1.04916H4.24032C4.6531 1.04916 4.97057 1.13809 5.18387 1.3135C5.40263 1.49398 5.51358 1.73319 5.51358 2.02474C5.51358 2.21681 5.45914 2.39456 5.35185 2.55316C5.24575 2.70976 5.09091 2.82426 4.89293 2.89487L5.5559 3.73683L6.38733 2.67257C6.41884 2.62634 6.48629 2.56514 6.60844 2.56514C6.6854 2.56514 6.75558 2.5934 6.81132 2.64679C6.86835 2.70187 6.8983 2.77219 6.8983 2.85071C6.8983 2.9123 6.8802 2.96842 6.84452 3.01738L5.89615 4.18751L6.84127 5.34944C6.88085 5.39345 6.90247 5.45374 6.90247 5.52484C6.90247 5.60518 6.87408 5.67693 6.82043 5.73227C6.766 5.78879 6.69269 5.81887 6.60844 5.81887C6.51351 5.81887 6.43199 5.77655 6.37275 5.69646L5.53076 4.63819L4.69894 5.70298C4.61833 5.79921 4.52979 5.81887 4.46924 5.81887C4.39423 5.81887 4.326 5.79022 4.27157 5.73592C4.21688 5.68162 4.18797 5.61313 4.18797 5.53773C4.18797 5.4695 4.20789 5.40856 4.24722 5.3566L5.19428 4.19207L4.2966 3.08653H3.53376V3.98711C3.53376 4.06888 3.50303 4.14155 3.44495 4.19728C3.38766 4.25223 3.31525 4.28127 3.23543 4.28127C3.1547 4.28127 3.08256 4.25171 3.02669 4.19585C2.97096 4.14024 2.9414 4.0681 2.9414 3.98711V1.34748ZM7.55681 14.183H2.28693C2.13966 14.183 2.02025 14.0635 2.02025 13.9163C2.02025 13.769 2.13966 13.6496 2.28693 13.6496H7.55681C7.70408 13.6496 7.82349 13.769 7.82349 13.9163C7.82349 14.0635 7.70408 14.183 7.55681 14.183ZM7.55681 12.5089H2.28693C2.13966 12.5089 2.02025 12.3895 2.02025 12.2422C2.02025 12.0949 2.13966 11.9755 2.28693 11.9755H7.55681C7.70408 11.9755 7.82349 12.0949 7.82349 12.2422C7.82349 12.3895 7.70408 12.5089 7.55681 12.5089ZM7.55681 10.8348H2.28693C2.13966 10.8348 2.02025 10.7154 2.02025 10.5681C2.02025 10.4209 2.13966 10.3015 2.28693 10.3015H7.55681C7.70408 10.3015 7.82349 10.4209 7.82349 10.5681C7.82349 10.7154 7.70408 10.8348 7.55681 10.8348Z"
                  fill="#757575"
                />
                <path
                  d="M11.3252 8.35156C11.0759 8.35156 10.873 8.55444 10.873 8.80368C10.873 9.05721 11.0716 9.25592 11.3252 9.25592C11.5745 9.25592 11.7774 9.05304 11.7774 8.80368C11.7774 8.55444 11.5745 8.35156 11.3252 8.35156Z"
                  fill="#757575"
                />
                <path
                  d="M11.3252 11.0625C11.0759 11.0625 10.873 11.2654 10.873 11.5146C10.873 11.7681 11.0716 11.9667 11.3252 11.9667C11.5745 11.9667 11.7774 11.7638 11.7774 11.5146C11.7774 11.2654 11.5745 11.0625 11.3252 11.0625Z"
                  fill="#757575"
                />
                <path
                  d="M10.1625 2.79643L12.1128 2.67806L10.7074 1.2728L9.81055 0.376953V2.44445C9.81055 2.63848 9.9685 2.79643 10.1625 2.79643Z"
                  fill="#757575"
                />
                <path
                  d="M4.74682 2.38508C4.86363 2.30629 4.9204 2.19808 4.9204 2.05407C4.9204 1.91395 4.87235 1.81043 4.77365 1.73764C4.66661 1.65899 4.47102 1.61914 4.19249 1.61914H3.5332V2.51477H4.21398C4.43977 2.51477 4.61908 2.47115 4.74682 2.38508Z"
                  fill="#757575"
                />
                <path
                  d="M15.5665 7.03125H9.85171C9.72136 7.03125 9.61523 7.13894 9.61523 7.27124V15.7609C9.61523 15.8933 9.72136 16.001 9.85171 16.001H15.5665C15.699 16.001 15.8067 15.8933 15.8067 15.7609V7.27124C15.8067 7.13894 15.699 7.03125 15.5665 7.03125ZM11.3255 15.2123C10.7821 15.2123 10.34 14.7702 10.34 14.2268C10.34 13.6834 10.7821 13.2413 11.3255 13.2413C11.869 13.2413 12.3111 13.6834 12.3111 14.2268C12.3111 14.7702 11.869 15.2123 11.3255 15.2123ZM11.3255 12.5015C10.7821 12.5015 10.34 12.0594 10.34 11.516C10.34 10.9727 10.7821 10.5306 11.3255 10.5306C11.869 10.5306 12.3111 10.9727 12.3111 11.516C12.3111 12.0594 11.869 12.5015 11.3255 12.5015ZM11.3255 9.79093C10.7821 9.79093 10.34 9.34885 10.34 8.80532C10.34 8.26193 10.7821 7.81984 11.3255 7.81984C11.869 7.81984 12.3111 8.26193 12.3111 8.80532C12.3111 9.34885 11.869 9.79093 11.3255 9.79093ZM14.0963 15.2123C13.5529 15.2123 13.1108 14.7702 13.1108 14.2268C13.1108 13.6834 13.5529 13.2413 14.0963 13.2413C14.6396 13.2413 15.0817 13.6834 15.0817 14.2268C15.0817 14.7702 14.6396 15.2123 14.0963 15.2123ZM14.0963 12.5015C13.5529 12.5015 13.1108 12.0594 13.1108 11.516C13.1108 10.9727 13.5529 10.5306 14.0963 10.5306C14.6396 10.5306 15.0817 10.9727 15.0817 11.516C15.0817 12.0594 14.6396 12.5015 14.0963 12.5015ZM14.0963 9.79093C13.5529 9.79093 13.1108 9.34885 13.1108 8.80532C13.1108 8.26193 13.5529 7.81984 14.0963 7.81984C14.6396 7.81984 15.0817 8.26193 15.0817 8.80532C15.0817 9.34885 14.6396 9.79093 14.0963 9.79093Z"
                  fill="#757575"
                />
                <path
                  d="M14.0966 14.6775C14.3462 14.6775 14.5486 14.4751 14.5486 14.2255C14.5486 13.9758 14.3462 13.7734 14.0966 13.7734C13.8469 13.7734 13.6445 13.9758 13.6445 14.2255C13.6445 14.4751 13.8469 14.6775 14.0966 14.6775Z"
                  fill="#757575"
                />
                <path
                  d="M14.0966 11.9666C14.3462 11.9666 14.5486 11.7642 14.5486 11.5145C14.5486 11.2649 14.3462 11.0625 14.0966 11.0625C13.8469 11.0625 13.6445 11.2649 13.6445 11.5145C13.6445 11.7642 13.8469 11.9666 14.0966 11.9666Z"
                  fill="#757575"
                />
                <path
                  d="M14.0966 8.35156C13.8474 8.35156 13.6445 8.55444 13.6445 8.80368C13.6445 9.05721 13.8431 9.25592 14.0966 9.25592C14.3459 9.25592 14.5488 9.05304 14.5488 8.80368C14.5488 8.55444 14.3459 8.35156 14.0966 8.35156Z"
                  fill="#757575"
                />
              </svg>
            }
            >

Rx Manager

          </MenuItem>
        </OverlayTrigger>


      </>
    )
  }

  const renderdrugcatalogr = () => {
     if (hasModule('DC'))
    return (
      <>
        <OverlayTrigger
          overlay={(props) => (
            <Tooltip {...props}>
              Drug Catalog
            </Tooltip>
          )}
          // onHide={open == false}
          placement="right"
          show={show && target == "Drug Catalog"}
        >
          <MenuItem component={<Link className={`${(includes(pathname, "/drugcatalog")) ? "active" : ""}`} to="/drugcatalog" />}
            id="Drug Catalog"
            onMouseEnter={() => handleMouseEnter("Drug Catalog")}
            onMouseLeave={handleMouseLeave}

            icon={
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_2578_148830)">
                  <g clip-path="url(#clip1_2578_148830)">
                    <g clip-path="url(#clip2_2578_148830)">
                      <path
                        d="M2.84584 1.84766V11.0345L0.0308356 3.36453C-0.0588519 3.12078 0.0673981 2.85047 0.311773 2.76234L2.84584 1.84766Z"
                        fill="#757575"
                      />
                      <path
                        d="M15.9685 3.36461L13.1582 11.0218V1.84961L15.6876 2.76242C15.932 2.85055 16.0579 3.12086 15.9685 3.36461Z"
                        fill="#757575"
                      />
                      <path
                        d="M11.752 0H4.25195C3.9932 0 3.7832 0.21 3.7832 0.46875V15.5312C3.7832 15.79 3.9932 16 4.25195 16H11.752C12.0107 16 12.2207 15.79 12.2207 15.5312V0.46875C12.2207 0.21 12.0107 0 11.752 0ZM8.93945 13.1875H6.12695C5.8682 13.1875 5.6582 12.9775 5.6582 12.7188C5.6582 12.46 5.8682 12.25 6.12695 12.25H8.93945C9.1982 12.25 9.4082 12.46 9.4082 12.7188C9.4082 12.9775 9.1982 13.1875 8.93945 13.1875ZM9.87695 11.3125H6.12695C5.8682 11.3125 5.6582 11.1025 5.6582 10.8438C5.6582 10.585 5.8682 10.375 6.12695 10.375H9.87695C10.1357 10.375 10.3457 10.585 10.3457 10.8438C10.3457 11.1025 10.1357 11.3125 9.87695 11.3125ZM9.87695 9.4375H7.06445C6.8057 9.4375 6.5957 9.2275 6.5957 8.96875C6.5957 8.71 6.8057 8.5 7.06445 8.5H9.87695C10.1357 8.5 10.3457 8.71 10.3457 8.96875C10.3457 9.2275 10.1357 9.4375 9.87695 9.4375ZM10.3457 6.15625C10.3457 6.415 10.1357 6.625 9.87695 6.625H6.12695C5.8682 6.625 5.6582 6.415 5.6582 6.15625V3.34375C5.6582 3.085 5.8682 2.875 6.12695 2.875H9.87695C10.1357 2.875 10.3457 3.085 10.3457 3.34375V6.15625Z"
                        fill="#757575"
                      />
                      <path
                        d="M6.5957 3.8125H9.4082V5.6875H6.5957V3.8125Z"
                        fill="#757575"
                      />
                    </g>
                  </g>
                </g>
                <defs>
                  <clipPath id="clip0_2578_148830">
                    <rect width="16" height="16" fill="white" />
                  </clipPath>
                  <clipPath id="clip1_2578_148830">
                    <rect width="16" height="16" fill="white" />
                  </clipPath>
                  <clipPath id="clip2_2578_148830">
                    <rect width="16" height="16" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            }
          >
            Drug Catalog
          </MenuItem>
        </OverlayTrigger>


      </>
    )
  }


  const collapse = () => {
    return (
      <MenuItem component={<Link onClick={() => setOpen(!open)} />}
        icon={open ? (
          <FontAwesomeIcon style={{ color: "757575" }} icon={faChevronCircleRight} className="fa-fw" />
        ) : (
          <FontAwesomeIcon style={{ color: "757575" }} icon={faChevronCircleLeft} className="fa-fw" />
        )
        }>
        Collapse
      </MenuItem>
    )
  }

  return (
    <div>
      <div className="app-sider">
        <div className="app-sider-inner">
          <Sidebar collapsed={open}>
            <Menu closeOnClick={true}>
              {renderDashboard()}
              {renderPurchaseOrder()}
              {renderInventory()}
              {renderreports()}
              {/* {rendercontracts()} */}
           
              {renderformulary()}
              {renderinvoice()}
              {renderrxmanager()}
              {renderdrugcatalogr()}
              {renderConfiguration()}
              {collapse()}
            </Menu>
          </Sidebar>
        </div>
      </div>
    </div>
  );
};

export default SideBar;